import { Status } from '@/models/CommonModels';

import { MutationTree } from 'vuex';
import { State } from './state';

export enum MutationTypes {
  SetStatus = 'SETSTATUS',
  SetLanguage = 'SETLANGUAGE',
}

export type Mutations = {
  [MutationTypes.SetStatus](state: State, status: Status): void;
  [MutationTypes.SetLanguage](state: State, lang: string): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SetStatus](state: State, status: Status) {
    state.status = status;
  },

  [MutationTypes.SetLanguage](state: State, lang: string) {
    state.language = lang;
    localStorage.setItem('language', lang);
  },
};
